import axios from "axios";
import router from "@/router";
//import { useConfigStore } from "@/stores/config.js";
var url_atual = window.location.href;
let index_ = url_atual.indexOf("localhost");
let url_ = "";
if (index_ == -1) {
  //url_ = "https://www.servicos-administrativos.online/servicosadministrativos";
  url_ = "https://www.servicos-administrativos.online/api";
} else {
  //url_ = "https://g-ale.net/apidev/G"
  url_ = "http://localhost:3000";
  // url_="https://g-ale.net/apidev/G"
}
const baseUrlMain = url_;

const ServerServices = axios.create({
  baseURL: baseUrlMain,
  timeout: 50000,
  withCredentials: true,
});

// Interceptor de loading global
let requests = 0;
/*function setLoading(val) {
  try {
    const store = useConfigStore();
    store.setLoading(val);
  } catch {
    / ignore 
  }
}*/

ServerServices.interceptors.request.use(
  (config) => {
    requests++;
    //  setLoading(true);

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    requests = Math.max(0, requests - 1);
    //if (requests === 0) setLoading(false);
    return Promise.reject(error);
  }
);

ServerServices.interceptors.response.use(
  (response) => {
    requests = Math.max(0, requests - 1);
    //  if (requests === 0) setLoading(false);
    return response;
  },
  (error) => {
    requests = Math.max(0, requests - 1);
    //  if (requests === 0) setLoading(false);

    // Verificar status 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      router.push({ name: "Login" });
    }

    return Promise.reject(error);
  }
);

export default ServerServices;
